/**
 * Include your custom JavaScript here.
 *
 * Hooks disponibles (Maestrooo):
 *   document.addEventListener('variant:changed', e => { e.detail.variant });
 *   document.addEventListener('product:added', e => { e.detail.variant; e.detail.quantity });
 *   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
 */

/* ============================================================
 * EMMA MONTIEL - estilos inyectados via custom.js (upgrade-safe)
 * Decisiones de CRO/UX/branding documentadas en el chat.
 * ============================================================ */
(function () {
  var css = `
/* Precio: presencia, no gris atenuado */
.template-product .ProductMeta__PriceList .ProductMeta__Price{ color: var(--text-color); font-weight: 600; font-size: 1.6rem; opacity: 1; }
.template-product .ProductMeta__PriceList .Price--compareAt{ color: var(--text-color-light); text-decoration: line-through; font-weight: 400; margin-left: .5em; }
/* Bloques de texto de marca en la columna de compra */
.template-product .ProductMeta + .ProductMeta__Text:first-of-type,
.template-product .ProductMeta__Text:first-of-type{ margin-top: .4rem; margin-bottom: 1.6rem; font-size: 1.05rem; line-height: 1.5; color: var(--text-color-light); letter-spacing: .01em; }
/* Boton Anadir al carrito */
.template-product .ProductForm__AddToCart{ font-weight: 600; letter-spacing: .04em; }
/* Fila de confianza bajo el boton */
.template-product .ProductForm__BuyButtons + .ProductMeta__Text{ margin-top: 1rem; text-align: center; font-size: .82rem; line-height: 1.5; color: var(--text-color-light); letter-spacing: .02em; }
/* Acordeones compactos */
.template-product .Product__Tabs .Collapsible{ border-top: 1px solid var(--border-color); }
.template-product .Product__Tabs .Collapsible:last-child{ border-bottom: 1px solid var(--border-color); }
.template-product .Product__Tabs .Collapsible__Button{ padding-top: 1.1rem; padding-bottom: 1.1rem; }
/* Ocultar powered-by Shopify (senal de tema demo) en todo el site */
.Footer__ThemeAuthor{ display: none; }
`;
  var style = document.createElement('style');
  style.setAttribute('data-em-pdp', '');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
})();